// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"bb05fbe31177bc59","4049":"75db7ebc8d86b214","5372":"75db7ebc8d86b214","6163":"75db7ebc8d86b214"}[chunkId] + ".css";
};